// File: src/components/pages/admin/AdminManageTracker.jsx
// Admin wrapper page for managing TrackerDefaultTemplates

import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import AdminDefaultTemplates from './AdminDefaultTemplates';
import { AUTH0_NAMESPACE } from '../../../utils/constants';
import '../../../styles/unified.css';

export default function AdminManageTracker() {
  const { user } = useAuth0();
  const userRoles = user?.[`${AUTH0_NAMESPACE}/roles`] || [];
  const isAdmin = userRoles.includes('admin');

  const [activeTab, setActiveTab] = useState('default-templates');

  const tabs = [
    { key: 'default-templates', label: 'Default Templates', color: '#7c3aed' }
  ];

  if (!isAdmin) {
    return (
      <div className="access-denied-container">
        <h2>Access Denied</h2>
        <p>This page is only accessible to administrators.</p>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="status-tabs">
        {tabs.map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`status-tab ${activeTab === tab.key ? 'active' : ''}`}
            style={{
              '--tab-color': tab.color,
              borderBottomColor: activeTab === tab.key ? tab.color : 'transparent'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="page-content">
        {activeTab === 'default-templates' && <AdminDefaultTemplates />}
      </div>
    </div>
  );
}
